var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"progress"}},[_c('div',{style:({ width: _vm.$store.state.progress + '%' })})]),_vm._v(" "),_c('site-header'),_vm._v(" "),_c('sidebar'),_vm._v(" "),_c('main',[_c('router-view',{on:{"css":function($event){_vm.$emit('update:css')}}})],1),_vm._v(" "),_c('prompts')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-272421b8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Layout.vue
// module id = 374
// module chunks = 0